import { IdlePeriodSettingsModel } from 'src/Libs/smart-charge/models'
import { IdlePeriodsSettingsDto } from 'src/Libs/smart-charge/dto'

const fromDtoToModelTransformer = (dto: IdlePeriodsSettingsDto): IdlePeriodSettingsModel => ({
  emsGetIdlePeriodsEnable: dto.emsGetIdlePeriodsEnable,
  emsIdlePeriod: (dto.emsIdlePeriod || []).map(item => ({
    isActive: item.emsPeriodActive,
    name: item.emsPeriodName,
    peridodType: item.emsPeriodType,
    start: item.emsPeriodStart,
    stop: item.emsPeriodStop,
    weekdays: item.emsPeriodWeekdays,
  })),
})

export default fromDtoToModelTransformer
